(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["palm-grace-editorial-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root = document) => {
      root.querySelectorAll('[data-pg-ready-carousel]:not([data-pg-ready-initialized])').forEach((carousel) => {
        carousel.dataset.pgReadyInitialized = 'true';
        const slides = [...carousel.querySelectorAll('[data-pg-ready-slide]')];
        const dots = [...carousel.querySelectorAll('[data-pg-ready-dot]')];
        const toggle = carousel.querySelector('[data-pg-ready-toggle]');
        const icon = carousel.querySelector('[data-pg-ready-toggle-icon]');
        const link = carousel.querySelector('.pg-ready-carousel__link');
        const interval = Number(carousel.dataset.interval) || 6500;
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        let current = 0;
        let timer;
        let paused = reducedMotion;
        let touchStartX = 0;
        let touchStartY = 0;
        let swiped = false;

        const show = (next) => {
          current = (next + slides.length) % slides.length;
          slides.forEach((slide, index) => {
            const active = index === current;
            slide.classList.toggle('is-active', active);
            slide.setAttribute('aria-hidden', active ? 'false' : 'true');
            dots[index]?.classList.toggle('is-active', active);
          });
        };

        const stop = () => {
          window.clearInterval(timer);
          timer = undefined;
        };

        const start = () => {
          stop();
          if (!paused && document.visibilityState === 'visible') {
            timer = window.setInterval(() => show(current + 1), interval);
          }
        };

        const setPaused = (nextPaused) => {
          paused = nextPaused;
          toggle.setAttribute('aria-label', paused ? carousel.dataset.playLabel : carousel.dataset.pauseLabel);
          icon.textContent = paused ? '▶' : 'Ⅱ';
          start();
        };

        toggle.addEventListener('click', () => setPaused(!paused));
        carousel.addEventListener('mouseenter', stop);
        carousel.addEventListener('mouseleave', start);
        carousel.addEventListener('focusin', stop);
        carousel.addEventListener('focusout', start);
        link.addEventListener('touchstart', (event) => {
          touchStartX = event.changedTouches[0].clientX;
          touchStartY = event.changedTouches[0].clientY;
          swiped = false;
          if (carousel.dataset.pauseOnInteraction === 'true') {
            setPaused(true);
          }
        }, { passive: true });
        link.addEventListener('touchend', (event) => {
          const deltaX = event.changedTouches[0].clientX - touchStartX;
          const deltaY = event.changedTouches[0].clientY - touchStartY;
          if (Math.abs(deltaX) > 45 && Math.abs(deltaX) > Math.abs(deltaY)) {
            swiped = true;
            show(current + (deltaX < 0 ? 1 : -1));
            if (carousel.dataset.pauseOnInteraction !== 'true') {
              start();
            }
          }
        }, { passive: true });
        link.addEventListener('click', (event) => {
          if (swiped) {
            event.preventDefault();
            swiped = false;
          }
        });
        document.addEventListener('visibilitychange', start);
        show(0);
        setPaused(paused);
      });
    };

    initialize();
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["palm-grace-ready-made-box"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('palm-grace-ready-box')) {
    class PalmGraceReadyBox extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        this.variants = new Map();
        this.querySelectorAll('[data-pgrb-variant]').forEach((node) => {
          this.variants.set(node.dataset.key, {
            id: node.dataset.id,
            price: Number(node.dataset.price),
            available: node.dataset.available === 'true'
          });
        });
        this.querySelectorAll('[data-pgrb-toggle]').forEach((input) => {
          input.addEventListener('change', () => this.update());
        });
        this.querySelector('[data-pgrb-quantity]').addEventListener('input', () => this.update());
        this.update();
      }

      format(cents) {
        const amount = cents / 100;
        return `GHS ${Number.isInteger(amount) ? amount.toFixed(0) : amount.toFixed(2)}`;
      }

      update() {
        const selections = {
          logo: this.querySelector('[data-pgrb-toggle="logo"]').checked,
          interior: this.querySelector('[data-pgrb-toggle="interior"]').checked,
          ribbon: this.querySelector('[data-pgrb-toggle="ribbon"]')?.checked || false
        };
        const selectedSize = this.dataset.sizeValue;
        const quantityInput = this.querySelector('[data-pgrb-quantity]');
        const quantity = Math.max(1, Number.parseInt(quantityInput.value, 10) || 1);
        quantityInput.value = quantity;

        Object.entries(selections).forEach(([name, selected]) => {
          const details = this.querySelector(`[data-pgrb-details="${name}"]`);
          const summary = this.querySelector(`[data-pgrb-summary="${name}"]`);
          if (!details || !summary) return;
          details.hidden = !selected;
          summary.hidden = !selected;
          details.querySelectorAll('input').forEach((input) => {
            input.disabled = !selected;
            if (input.hasAttribute('data-pgrb-required')) input.required = selected;
          });
        });

        let customization = 'Plain';
        if (selections.logo && selections.interior && selections.ribbon) customization = 'Logo + Interior + Ribbon';
        else if (selections.logo && selections.interior) customization = 'Logo + Interior';
        else if (selections.logo && selections.ribbon) customization = 'Logo + Ribbon';
        else if (selections.interior && selections.ribbon) customization = 'Interior + Ribbon';
        else if (selections.logo) customization = 'Logo on Top';
        else if (selections.interior) customization = 'Interior Branding';
        else if (selections.ribbon) customization = 'Personalized Ribbon';

        const key = `${selectedSize}|${customization}`;
        const variant = this.variants.get(key);
        if (!variant) return;

        this.querySelector('[data-pgrb-variant-id]').value = variant.id;
        this.querySelector('[data-pgrb-size-property]').value = selectedSize;
        this.querySelector('[data-pgrb-size-summary]').textContent = selectedSize;
        this.querySelector('[data-pgrb-quantity-summary]').textContent = quantity;
        const total = this.format(variant.price * quantity);
        this.querySelector('[data-pgrb-total]').textContent = total;
        this.querySelector('[data-pgrb-total-property]').value = total;
        this.querySelector('[data-pgrb-submit]').disabled = !variant.available;
      }
    }

    customElements.define('palm-grace-ready-box', PalmGraceReadyBox);
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["palm-grace-ribbon-roll"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ribbon-roll')) {
    customElements.define('ribbon-roll', class extends HTMLElement {
      connectedCallback() {
        this.variantId = this.querySelector('[data-ribbon-variant-id]');
        this.property = this.querySelector('[data-ribbon-property]');
        this.quantity = this.querySelector('[data-ribbon-quantity]');
        this.selected = this.querySelector('[data-ribbon-selected]');
        this.total = this.querySelector('[data-ribbon-total]');
        this.submit = this.querySelector('[data-ribbon-submit]');
        this.colours = [...this.querySelectorAll('[data-ribbon-colour]')];
        this.colours.forEach((colour) => colour.addEventListener('change', () => this.update()));
        this.quantity.addEventListener('input', () => this.update());
        this.update();
      }

      update() {
        const colour = this.colours.find((item) => item.checked);
        const quantity = Math.max(1, Number.parseInt(this.quantity.value, 10) || 1);
        const price = Number.parseInt(colour.dataset.price, 10);
        this.variantId.value = colour.dataset.variantId;
        this.property.value = colour.value;
        this.selected.textContent = colour.value;
        this.total.textContent = `${this.dataset.currency} ${Math.round((price * quantity) / 100).toLocaleString()}`;
        this.submit.disabled = colour.dataset.available !== 'true';
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["palm-grace-shopping-paths"] && !Shopify.designMode) return;
  try {
    
  class PalmGraceConfigurator {
    constructor(root) {
      if (root.dataset.pgReady === 'true') return;
      root.dataset.pgReady = 'true';
      this.root = root;
      this.form = root.querySelector('[data-pg-form]');
      this.quantity = root.querySelector('[data-pg-quantity]');
      this.error = root.querySelector('[data-pg-quantity-error]');
      this.prices = JSON.parse(root.dataset.prices);
      this.variants = JSON.parse(root.dataset.variants);
      this.designVariant = Number.parseInt(root.dataset.designVariant, 10);
      this.colour = root.querySelector('[data-pg-colour]');
      this.notes = root.querySelector('[data-pg-notes]');
      this.files = root.querySelector('[data-pg-files]');
      this.uploadLabel = root.querySelector('[data-pg-upload-label]');
      this.uploadHelp = root.querySelector('[data-pg-upload-help]');
      this.checkoutButton = root.querySelector('[data-pg-checkout]');
      this.checkoutError = root.querySelector('[data-pg-checkout-error]');
      this.checkoutLabel = this.checkoutButton.textContent;
      this.form.addEventListener('change', () => this.update());
      this.form.addEventListener('submit', (event) => this.checkout(event));
      this.quantity.addEventListener('input', () => this.update());
      this.quantity.addEventListener('blur', () => this.normalizeQuantity());
      this.colour.addEventListener('input', () => this.update());
      root.querySelectorAll('[data-pg-quantity-preset]').forEach((button) => {
        button.addEventListener('click', () => {
          this.quantity.value = button.dataset.pgQuantityPreset;
          this.update();
        });
      });
      this.update();
    }

    selected(name) {
      return this.form.querySelector('input[name^="' + name + '"]:checked');
    }

    amount(value) {
      return new Intl.NumberFormat('en-GH', {
        style: 'currency',
        currency: 'GHS',
        minimumFractionDigits: Number.isInteger(value) ? 0 : 2,
        maximumFractionDigits: 2
      }).format(value).replace('GH₵', 'GHS');
    }

    quantityValue() {
      const parsed = Number.parseInt(this.quantity.value, 10);
      return Number.isFinite(parsed) ? Math.max(parsed, 100) : 100;
    }

    moneyValue(value) {
      return Math.round((value + Number.EPSILON) * 100) / 100;
    }

    normalizeQuantity() {
      this.quantity.value = this.quantityValue();
      this.update();
    }

    currentSummary() {
      const material = this.selected('material');
      const size = this.selected('size');
      const print = this.selected('print');
      const design = this.selected('design');
      const quantity = this.quantityValue();
      const hundredPrice = this.prices[material.value][size.value][print.value];
      const unitRate = this.moneyValue(hundredPrice / 100);
      const production = this.moneyValue(unitRate * quantity);
      const designFee = design.value === 'service' ? 180 : 0;
      return {
        materialKey: material.value,
        sizeKey: size.value,
        printKey: print.value,
        designKey: design.value,
        material: material.dataset.label,
        size: size.dataset.label,
        print: print.dataset.label,
        quantity,
        design: design.dataset.label,
        unitRate,
        production,
        designFee,
        total: this.moneyValue(production + designFee)
      };
    }

    update() {
      const rawQuantity = Number.parseInt(this.quantity.value, 10);
      const invalid = Number.isFinite(rawQuantity) && rawQuantity < 100;
      this.error.hidden = !invalid;
      this.quantity.setAttribute('aria-invalid', invalid ? 'true' : 'false');
      const summary = this.currentSummary();
      this.root.querySelector('[data-pg-summary-material]').textContent = summary.material;
      this.root.querySelector('[data-pg-summary-size]').textContent = summary.size;
      this.root.querySelector('[data-pg-summary-print]').textContent = summary.print;
      this.root.querySelector('[data-pg-summary-quantity]').textContent = summary.quantity;
      this.root.querySelector('[data-pg-summary-design]').textContent = summary.design;
      this.root.querySelector('[data-pg-summary-colour]').textContent = this.colour.value.trim() || this.root.dataset.notProvided;
      this.root.querySelector('[data-pg-unit-rate]').textContent = this.amount(summary.unitRate);
      this.root.querySelector('[data-pg-production]').textContent = this.amount(summary.production);
      this.root.querySelector('[data-pg-artwork]').textContent = this.amount(summary.designFee);
      this.root.querySelector('[data-pg-total]').textContent = this.amount(summary.total);
      const usesDesignService = summary.designKey === 'service';
      this.uploadLabel.textContent = usesDesignService ? this.root.dataset.uploadServiceLabel : this.root.dataset.uploadOwnLabel;
      this.uploadHelp.textContent = usesDesignService ? this.root.dataset.uploadServiceHelp : this.root.dataset.uploadOwnHelp;
    }

    propertyName(key) {
      return this.root.dataset['property' + key];
    }

    async addProduction(summary) {
      const data = new FormData();
      const variantId = this.variants[summary.materialKey][summary.sizeKey][summary.printKey];
      data.append('id', variantId);
      data.append('quantity', summary.quantity);
      data.append('properties[' + this.propertyName('Material') + ']', summary.material);
      data.append('properties[' + this.propertyName('Size') + ']', summary.size);
      data.append('properties[' + this.propertyName('Print') + ']', summary.print);
      data.append('properties[' + this.propertyName('Design') + ']', summary.design);
      data.append('properties[' + this.propertyName('Colour') + ']', this.colour.value.trim());
      if (this.notes.value.trim()) {
        data.append('properties[' + this.propertyName('Notes') + ']', this.notes.value.trim());
      }
      Array.from(this.files.files).forEach((file, index) => {
        data.append('properties[' + this.propertyName('Reference') + ' ' + (index + 1) + ']', file, file.name);
      });
      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: data
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message);
      return result;
    }

    async addDesignService(summary) {
      const properties = {};
      properties[this.propertyName('Material')] = summary.material;
      properties[this.propertyName('Size')] = summary.size;
      properties[this.propertyName('Print')] = summary.print;
      properties[this.propertyName('Colour')] = this.colour.value.trim();
      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: this.designVariant, quantity: 1, properties }] })
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message);
    }

    async removeProduction(key) {
      if (!key) return;
      await fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      });
    }

    async checkout(event) {
      event.preventDefault();
      this.normalizeQuantity();
      if (!this.form.reportValidity()) return;
      const summary = this.currentSummary();
      this.checkoutError.hidden = true;
      this.checkoutButton.disabled = true;
      this.checkoutButton.textContent = this.root.dataset.checkoutWorking;
      let productionItem;
      try {
        productionItem = await this.addProduction(summary);
        if (summary.designKey === 'service') await this.addDesignService(summary);
        window.location.assign(window.Shopify.routes.root + 'checkout');
      } catch (error) {
        if (productionItem && summary.designKey === 'service') {
          try {
            await this.removeProduction(productionItem.key);
          } catch (cleanupError) {
            this.checkoutError.textContent = error.message || this.root.dataset.checkoutErrorCopy;
          }
        }
        this.checkoutError.textContent = error.message || this.root.dataset.checkoutErrorCopy;
        this.checkoutError.hidden = false;
        this.checkoutButton.disabled = false;
        this.checkoutButton.textContent = this.checkoutLabel;
      }
    }
  }

  const initializePalmGraceConfigurators = (scope = document) => {
    scope.querySelectorAll('[data-pg-configurator]').forEach((root) => new PalmGraceConfigurator(root));
  };

  initializePalmGraceConfigurators();
  document.addEventListener('shopify:section:load', (event) => initializePalmGraceConfigurators(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["palm-grace-shredded-paper"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const form = document.getElementById('PGShreddedForm');
    if (!form || form.dataset.ready === 'true') return;
    form.dataset.ready = 'true';
    const input = form.querySelector('[name="quantity"]');
    const count = form.querySelector('[data-pack-count]');
    const label = form.querySelector('[data-pack-label]');
    const total = form.querySelector('[data-total]');
    const update = () => {
      const quantity = Math.max(1, parseInt(input.value, 10) || 1);
      input.value = quantity;
      count.textContent = quantity;
      label.textContent = quantity === 1 ? 'pack' : 'packs';
      total.textContent = 'GHS ' + (quantity * 10).toLocaleString('en-GH');
    };
    form.querySelector('[data-quantity-minus]').addEventListener('click', () => {
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
      update();
    });
    form.querySelector('[data-quantity-plus]').addEventListener('click', () => {
      input.value = (parseInt(input.value, 10) || 1) + 1;
      update();
    });
    input.addEventListener('input', update);
    update();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["palm-grace-tissue-paper"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tissue-paper')) {
    customElements.define('tissue-paper', class extends HTMLElement {
      connectedCallback() {
        this.quantity = this.querySelector('[data-tissue-quantity]');
        this.pieces = this.querySelector('[data-tissue-pieces]');
        this.total = this.querySelector('[data-tissue-total]');
        this.quantity.addEventListener('input', () => this.update());
        this.quantity.addEventListener('change', () => this.update());
        this.update();
      }

      update() {
        const quantity = Math.max(1, Number.parseInt(this.quantity.value, 10) || 1);
        const sheets = quantity * 1000;
        const total = quantity * Number.parseInt(this.dataset.batchPrice, 10) / 100;
        this.pieces.textContent = `${quantity} × 1,000 = ${sheets.toLocaleString()} ${this.dataset.pieceLabel}`;
        this.total.textContent = `${this.dataset.currency} ${total.toLocaleString()}`;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
